import { PageRequestModel } from '@/models';
import OrderTaskHistoryTypeEnum from '../enums/OrderTaskHistoryTypeEnum';

/**
 * * Модель запроса на получение истории очередности
 */
export class GetOrderHistoryListRequestModel {
  /**
   * * Номер пользователя над кем было произведено действие
   */
  PerformerId!: number;
  /**
   * * Номер пользователя кто произвел действие
   */
  CreatorId?: number;
  /**
   * * Тип изменения очередности
   */
  Types!: Array<OrderTaskHistoryTypeEnum>;
  /**
   * * Дата начала получения записей
   */
  DateStart?: Date;
  /**
   * * Дата конца получения записей
   */
  DateEnd?: Date;
  /**
   * * Номер задачи
   */
  TaskId?: number;
  /**
   * * Пагинация
   */
  Page!: PageRequestModel;
  constructor(obj?: Partial<GetOrderHistoryListRequestModel>) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}
